import React, { useState } from 'react';
import { IDocument } from '../../Interfaces/IDocument';
import { DocumentOverview } from '../../Document/DocumentOverview';
import { CheckBox, Close, Download, Search } from '@mui/icons-material';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { SelectRequirement } from '../LegalPhase/SelectRequirement';
import { ILegalPhaseFullObject } from '../../Interfaces/ILegalPhase';
import { CustomeTextField } from '../../generic/CustomeTextField';
import { ILegalRequirementState } from '../../Interfaces/ILegalRequirementState';
import { IRealEstateLandRegisterEntryQuery } from '../../Interfaces/IRealEstateLandRegisterEntryQuery';
import { DocumentRow } from '../../Document/DocumentRow';
import { useSelector } from 'react-redux';
import { State } from '../../redux/mainReducer';
import { RealEstateLandRegisterEntryQueriesTable } from '../../RealEstate/RealEstateLandRegisterEntryQueriesTable';

interface IProps {
  realEstateLandRegisterEntryQueries: IRealEstateLandRegisterEntryQuery[];
  legalPhaseFullObjectArray: ILegalPhaseFullObject[];
  setLegalPhaseFullObjectArray: Function;
  legalReqStates: ILegalRequirementState[];
}

export const LandRegisterMainQueryDocument: React.FC<IProps> = ({
  realEstateLandRegisterEntryQueries,
  legalPhaseFullObjectArray,
  setLegalPhaseFullObjectArray,
  legalReqStates,
}) => {
  const [isOpenDocumentView, setIsOpenDocumentView] = useState(false);
  //
  const [checkedDokument, setCheckedDokument] = useState<number[]>([]);
  //
  const [isOpenCopyToReq, setIsOpenCopyToReq] = useState(false);
  const [targetIdReq, setTargetIdReq] = useState<number | null>(null);
  const [targetIdReqState, setTargetIdReqState] = useState(40);

  const onOpen = () => {
    setIsOpenCopyToReq(false);
    setCheckedDokument([]);
    setIsOpenDocumentView(true);
  };
  const onClose = () => {
    setIsOpenDocumentView(false);
  };

  const landParcelDocumentArray = realEstateLandRegisterEntryQueries
    .filter(query => query.idDocument !== null)
    .map(
      query =>
        ({
          idDocument: Number(query.idDocument),
          FileName: String(query.FileName),
          idMIMEType: Number(query.idMIMEType),
          Created_at: query.Created_at,
          idDocumentDirectory: null,
          idLegalTransaction: null,
          isFromTemplate: false,
          perEmail: false,
        }) as IDocument
    );

  const onCopyToReq = () => {
    const updated = legalPhaseFullObjectArray.map(phase => ({
      ...phase,
      LegalRequirementArray: phase.LegalRequirementArray.map(req => {
        // Zielanforderung gefunden?
        if (req.idLegalRequirement !== targetIdReq) return req;

        // vorhandenes Dokument anhand der IDs holen
        const docsToAdd = realEstateLandRegisterEntryQueries.filter(
          doc => doc.idDocument && checkedDokument.includes(doc.idDocument)
        );
        return {
          ...req,
          idLegalRequirementState: targetIdReqState,
          DocumentArrayEmployees: [
            ...(req.DocumentArrayEmployees ?? []),
            ...docsToAdd,
          ],
        };
      }),
    }));

    // State sauber setzen
    setLegalPhaseFullObjectArray(updated);

    // Checkboxen zurücksetzen etc.
    setCheckedDokument([]);
    setIsOpenCopyToReq(false);
    //
    setIsOpenCopyToReq(false);
    setIsOpenDocumentView(false);
  };

  if (realEstateLandRegisterEntryQueries.length === 0) {
    return <Close />;
  }

  return (
    <>
      {isOpenCopyToReq && (
        <Dialog
          open
          maxWidth='sm'
          fullWidth
          onClose={() => setIsOpenCopyToReq(false)}
        >
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item sm={6}>
                <SelectRequirement
                  idLegalRequirement={targetIdReq}
                  setIdLegalRequirement={setTargetIdReq}
                  legalPhases={legalPhaseFullObjectArray}
                />
              </Grid>
              <Grid item sm={6}>
                <CustomeTextField
                  label='Status'
                  attr='targetIdReqState'
                  object={{ targetIdReqState: targetIdReqState }}
                  setObject={(updatedData: { targetIdReqState: number }) => {
                    setTargetIdReqState(updatedData.targetIdReqState);
                  }}
                  type='select'
                >
                  {legalReqStates.map(state => (
                    <MenuItem
                      key={`select-pm-requirementstate-${state.idLegalRequirementState}`}
                      value={state.idLegalRequirementState}
                    >
                      {state.LegalRequirementState}
                    </MenuItem>
                  ))}
                </CustomeTextField>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              variant='outlined'
              onClick={() => setIsOpenCopyToReq(false)}
            >
              Abbruch
            </Button>
            <Button
              variant='contained'
              onClick={onCopyToReq}
              disabled={targetIdReq === null}
            >
              Kopieren
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {isOpenDocumentView && (
        <Dialog open maxWidth='md' fullWidth onClose={onClose}>
          <DialogContent>
            <Typography variant='h5'>Abfragen</Typography>
            <RealEstateLandRegisterEntryQueriesTable
              realEstateLandRegisterEntryQueries={
                realEstateLandRegisterEntryQueries
              }
              checkedDokument={checkedDokument}
              setCheckedDokument={setCheckedDokument}
            />

            <Button
              sx={{ mt: 1 }}
              variant='outlined'
              disabled={checkedDokument.length === 0}
              onClick={() => {
                setTargetIdReq(null);
                setIsOpenCopyToReq(true);
              }}
            >
              In Maßnahme kopieren
            </Button>
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' onClick={onClose}>
              schließen
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <IconButton onClick={onOpen}>
        <Download />
      </IconButton>
    </>
  );
};
